function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import ReactDOM from 'react-dom';
import { DateTime } from 'luxon';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faHandPointRight, faTimes } from '@fortawesome/free-solid-svg-icons';
import { FixedSizeList as List } from 'react-window';
import InfiniteCalendar from 'react-infinite-calendar';
import LogBookEntry from '../../model/LogBookEntry';
import { EntryWorkflow, AddRiderWorkflow } from './Workflows';
import LogBookEntryPanel from './LogBookEntryPanel';
import './LogBookPanel.css';
import './Calendar.css'; // TODO: weather conditions
// borders based on race type maybe change header colors
// edit workflow for name, date, series, location
// show workflow pane specifc to what was clicked
// edit workflows & filters for fast search of items in lists
// custom location name
// custom event name
// calendar icon to search for a specific date

var CALENDAR_THEME = {
  accentColor: 'rgba(var(--active-color), 1)',
  floatingNav: {
    background: 'rgba(var(--background-color), 0.9)',
    chevron: 'rgba(var(--active-color), 1)',
    color: 'rgba(var(--foreground-color), 1)'
  },
  headerColor: 'rgba(var(--background-color), 1)',
  selectionColor: 'rgba(var(--active-color), 1)',
  textColor: {
    active: 'rgba(var(--foreground-color), 1)',
    default: 'rgba(var(--foreground-color), 1)'
  },
  todayColor: 'rgba(var(--active-color), .5)',
  weekdayColor: 'rgba(var(--background-color), 1)'
};

var LogBookPanel = /*#__PURE__*/function (_React$Component) {
  _inherits(LogBookPanel, _React$Component);

  function LogBookPanel(props) {
    var _this;

    _classCallCheck(this, LogBookPanel);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(LogBookPanel).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "updateLogBook", function () {
      var storage = _this.props.storage;
      LogBookEntry.allIds(storage).then(function (entryIds) {
        _this.setState({
          entryIds: entryIds
        });
      });
    });

    _defineProperty(_assertThisInitialized(_this), "findReact", function (dom) {
      var traverseUp = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var key = Object.keys(dom).find(function (key) {
        return key.startsWith("__reactInternalInstance$");
      });
      var domFiber = dom[key];
      if (domFiber == null) return null; // react <16

      if (domFiber._currentElement) {
        var _compFiber = domFiber._currentElement._owner;

        for (var i = 0; i < traverseUp; i++) {
          _compFiber = _compFiber._currentElement._owner;
        }

        return _compFiber._instance;
      } // react 16+


      var GetCompFiber = function GetCompFiber(fiber) {
        //return fiber._debugOwner; // this also works, but is __DEV__ only
        var parentFiber = fiber.return;

        while (typeof parentFiber.type == "string") {
          parentFiber = parentFiber.return;
        }

        return parentFiber;
      };

      var compFiber = GetCompFiber(domFiber);

      for (var _i = 0; _i < traverseUp; _i++) {
        compFiber = GetCompFiber(compFiber);
      }

      return compFiber.stateNode;
    });

    _defineProperty(_assertThisInitialized(_this), "toggleNewEntryWorkflow", function () {
      _this.setState({
        showNewEntryWorkflow: !_this.state.showNewEntryWorkflow,
        currentLogBookEntry: undefined
      });
    });

    _defineProperty(_assertThisInitialized(_this), "setCurrentLogBookEntry", function (logBookEntry) {
      _this.setState({
        currentLogBookEntry: logBookEntry
      });
    });

    _defineProperty(_assertThisInitialized(_this), "clearCurrentLogBookEntry", function () {
      _this.setState({
        currentLogBookEntry: undefined
      });
    });

    _defineProperty(_assertThisInitialized(_this), "updateLogBookEntryById", function (id) {
      var _assertThisInitialize = _assertThisInitialized(_this),
          findReact = _assertThisInitialize.findReact;

      var node = document.getElementById("".concat(id));
      var component = node && findReact(node);

      if (component) {
        return component.updateLogBookEntry();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "addEntry", function (logBookEntry) {
      var storage = _this.props.storage;
      var entryIds = _this.state.entryIds;
      logBookEntry.save(storage).then(function () {
        entryIds.unshift(logBookEntry.id);

        _this.setState({
          entryIds: entryIds.slice(),
          showNewEntryWorkflow: false
        });
      }, function (error) {
        console.error(error);
      });
    });

    _defineProperty(_assertThisInitialized(_this), "editLogBookEntry", function (logBookEntry) {
      _this.setState({
        currentLogBookEntry: logBookEntry,
        showNewEntryWorkflow: true
      });
    });

    _defineProperty(_assertThisInitialized(_this), "editLogBookEntryDate", function (logBookEntry) {
      _this.setState({
        editDateLogbookEntry: logBookEntry,
        currentLogBookEntry: undefined,
        showNewEntryWorkflow: false
      });
    });

    _defineProperty(_assertThisInitialized(_this), "renderItem", function (_ref) {
      var index = _ref.index,
          key = _ref.key,
          style = _ref.style;

      var _assertThisInitialize2 = _assertThisInitialized(_this),
          deleteLogBookEntry = _assertThisInitialize2.deleteLogBookEntry,
          setCurrentLogBookEntry = _assertThisInitialize2.setCurrentLogBookEntry,
          editLogBookEntry = _assertThisInitialize2.editLogBookEntry,
          editLogBookEntryDate = _assertThisInitialize2.editLogBookEntryDate;

      var _this$props = _this.props,
          width = _this$props.width,
          height = _this$props.height,
          storage = _this$props.storage;
      var entryIds = _this.state.entryIds;
      var logBookEntryId = entryIds[index];

      var elementStyle = _extends({}, style);

      elementStyle.height = "".concat(height - 65 - 4, "px");
      return React.createElement("div", {
        className: "logbook-entry-container",
        key: logBookEntryId,
        style: elementStyle
      }, React.createElement(LogBookEntryPanel, {
        logBookEntryId: logBookEntryId,
        height: height - 65 - 25 - 4,
        width: width - 50,
        deleteLogBookEntry: deleteLogBookEntry,
        setCurrentLogBookEntry: setCurrentLogBookEntry,
        editLogBookEntry: editLogBookEntry,
        editLogBookEntryDate: editLogBookEntryDate,
        storage: storage
      }));
    });

    _defineProperty(_assertThisInitialized(_this), "snapBackToOffset", function (offset, delta) {
      var snapping = _this.state.snapping;

      var _assertThisInitialize3 = _assertThisInitialized(_this),
          listRef = _assertThisInitialize3.listRef,
          snapBackToOffset = _assertThisInitialize3.snapBackToOffset;

      var currentScrollOffset = listRef.current.state.scrollOffset;
      clearTimeout(_this.snapScrollTimeout);

      if (currentScrollOffset > offset) {
        var animate = function animate() {
          listRef.current.scrollTo(currentScrollOffset - delta);
          _this.snapScrollTimeout = setTimeout(function () {
            snapBackToOffset(offset, delta);
          }, 5);
        };

        if (!snapping) {
          _this.setState({
            snapping: true
          }, animate);
        } else {
          animate();
        }
      } else {
        _this.setState({
          snapping: false
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "snapForwardToOffset", function (offset, delta) {
      var snapping = _this.state.snapping;

      var _assertThisInitialize4 = _assertThisInitialized(_this),
          listRef = _assertThisInitialize4.listRef,
          snapForwardToOffset = _assertThisInitialize4.snapForwardToOffset;

      var currentScrollOffset = listRef.current.state.scrollOffset;
      clearTimeout(_this.scrollTimeout);

      if (currentScrollOffset < offset) {
        var animate = function animate() {
          listRef.current.scrollTo(currentScrollOffset + delta);
          _this.snapScrollTimeout = setTimeout(function () {
            snapForwardToOffset(offset, delta);
          }, 5);
        };

        if (!snapping) {
          _this.setState({
            snapping: true
          }, animate);
        } else {
          animate();
        }
      } else {
        _this.setState({
          snapping: false
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onScroll", function (opts) {
      var snapping = _this.state.snapping;

      var _assertThisInitialize5 = _assertThisInitialized(_this),
          listRef = _assertThisInitialize5.listRef,
          scrollTimeout = _assertThisInitialize5.scrollTimeout,
          snapScrollTimeout = _assertThisInitialize5.snapScrollTimeout,
          snapBackToOffset = _assertThisInitialize5.snapBackToOffset,
          snapForwardToOffset = _assertThisInitialize5.snapForwardToOffset;

      var width = _this.props.width;
      var scrollDirection = opts.scrollDirection,
          scrollOffset = opts.scrollOffset;

      if (snapping) {
        return;
      }

      clearTimeout(scrollTimeout);
      clearTimeout(snapScrollTimeout);

      switch (scrollDirection) {
        case 'forward':
          _this.scrollTimeout = setTimeout(function () {
            var desiredItem = Math.ceil(scrollOffset / width);
            var desiredScrollOffset = width * desiredItem;
            snapForwardToOffset(desiredScrollOffset, Math.abs(listRef.current.state.scrollOffset - desiredScrollOffset) / 10);
          }, 100);
          break;

        case 'backward':
          _this.scrollTimeout = setTimeout(function () {
            var desiredItem = Math.floor(scrollOffset / width);
            var desiredScrollOffset = width * desiredItem;
            snapBackToOffset(desiredScrollOffset, Math.abs(listRef.current.state.scrollOffset - desiredScrollOffset) / 10);
          }, 100);
          break;
      }
    });

    _defineProperty(_assertThisInitialized(_this), "deleteLogBookEntry", function (logBookEntry) {
      var entryIds = _this.state.entryIds;
      var idx = entryIds.indexOf(logBookEntry.id);

      if (idx >= 0) {
        entryIds.splice(idx, 1);

        _this.setState({
          entryIds: entryIds.slice()
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "selectLogBookEntryDate", function (selected) {
      var storage = _this.props.storage;
      var editDateLogbookEntry = _this.state.editDateLogbookEntry;
      editDateLogbookEntry.date = DateTime.fromJSDate(selected);

      _this.updateLogBookEntryById(editDateLogbookEntry.id).then(function () {
        _this.closeCalendar();
      });
    });

    _defineProperty(_assertThisInitialized(_this), "closeCalendar", function () {
      _this.setState({
        editDateLogbookEntry: undefined,
        currentLogBookEntry: undefined,
        showNewEntryWorkflow: false
      });
    });

    _this.state = {
      showNewEntryWorkflow: false,
      currentLogBookEntry: undefined,
      editDateLogbookEntry: undefined,
      entryIds: []
    };
    _this.listRef = React.createRef();
    return _this;
  }

  _createClass(LogBookPanel, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var updateLogBook = this.updateLogBook;
      updateLogBook();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var updateLogBook = this.updateLogBook;

      if (prevProps.activePanel !== this.props.activePanel && this.props.activePanel) {
        updateLogBook();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var toggleNewEntryWorkflow = this.toggleNewEntryWorkflow,
          clearCurrentLogBookEntry = this.clearCurrentLogBookEntry,
          addEntry = this.addEntry,
          renderItem = this.renderItem,
          onScroll = this.onScroll,
          updateLogBookEntryById = this.updateLogBookEntryById,
          updateLogBook = this.updateLogBook,
          selectLogBookEntryDate = this.selectLogBookEntryDate,
          closeCalendar = this.closeCalendar;
      var _this$props2 = this.props,
          app = _this$props2.app,
          width = _this$props2.width,
          height = _this$props2.height,
          storage = _this$props2.storage;
      var _this$state = this.state,
          showNewEntryWorkflow = _this$state.showNewEntryWorkflow,
          currentLogBookEntry = _this$state.currentLogBookEntry,
          editDateLogbookEntry = _this$state.editDateLogbookEntry,
          entryIds = _this$state.entryIds;
      var headerCaption = entryIds.length > 0 ? "".concat(entryIds.length, " entries") : '';
      return React.createElement("div", {
        className: "logbook",
        style: {
          width: "".concat(width, "px"),
          height: "".concat(height, "px")
        }
      }, React.createElement("div", {
        className: "header"
      }, React.createElement("div", {
        className: "spacer"
      }), React.createElement("div", {
        className: "logbook-entry-count"
      }, React.createElement("div", null, headerCaption)), React.createElement("div", {
        className: "btn ripple plus",
        onClick: toggleNewEntryWorkflow
      }, React.createElement(FontAwesomeIcon, {
        icon: faPlus,
        className: "icon"
      }))), entryIds.length === 0 && React.createElement("div", {
        className: "start-here"
      }, React.createElement("div", {
        className: "pointer"
      }, React.createElement(FontAwesomeIcon, {
        icon: faHandPointRight
      })), React.createElement("div", {
        className: "caption"
      }, "This is your logbook"), React.createElement("div", {
        className: "caption"
      }, "tap the plus to add a new logbook entry!")), React.createElement(List, {
        ref: this.listRef,
        className: "entries",
        height: height - 65 - 25 - 4,
        itemCount: entryIds.length,
        itemSize: width,
        layout: "horizontal",
        width: width,
        onScroll: onScroll
      }, renderItem), React.createElement("div", {
        className: "logbook-entry-date-selector ".concat(editDateLogbookEntry ? 'show' : 'hide'),
        style: {
          width: "".concat(width, "px"),
          height: "".concat(height - 35, "px")
        }
      }, React.createElement("div", {
        className: "close ripple",
        onClick: closeCalendar
      }, React.createElement(FontAwesomeIcon, {
        icon: faTimes
      })), editDateLogbookEntry && React.createElement(InfiniteCalendar, {
        width: width,
        height: height - 185,
        selected: editDateLogbookEntry && editDateLogbookEntry.date.toJSDate(),
        onSelect: selectLogBookEntryDate,
        theme: CALENDAR_THEME
      })), React.createElement(EntryWorkflow, {
        width: width,
        height: height,
        show: showNewEntryWorkflow,
        cancelEntry: toggleNewEntryWorkflow,
        storage: storage,
        addEntry: addEntry,
        logBookEntry: currentLogBookEntry,
        updateLogBookEntryById: updateLogBookEntryById,
        updateLogBook: updateLogBook
      }), React.createElement(AddRiderWorkflow, {
        width: width,
        height: height,
        show: !!currentLogBookEntry && !showNewEntryWorkflow,
        cancelEntry: clearCurrentLogBookEntry,
        storage: storage,
        logBookEntry: currentLogBookEntry,
        updateLogBookEntryById: updateLogBookEntryById,
        updateLogBook: updateLogBook
      }));
    }
  }]);

  return LogBookPanel;
}(React.Component);

export default LogBookPanel;